import { FunctionComponent, useEffect, useState } from "react";
import { DialogContent, Grid, TextField, FormHelperText, MenuItem, Chip, IconButton, DialogActions, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import file from "client-sdk/src/parcels/file";
import { Controller, useForm } from "react-hook-form";
import { RonadDropzone } from "../../../components/RonadDropzone";
import RonadIcons from "../../../components/iconComponent";
import { getCategories, getSubjects } from "../../../api/ticket/get";
import handleNotfication from "../../../utils/handleNotfication";
import handleError from "../../../utils/handleError";
import { createTicket } from "../../../api/ticket/create";
import authContext from "../../../authContext";
import { translate } from "../../../utils/helpers";
import { rulesOrderStatus, rulesAdminChangeOrderStatus } from "../../../utils/rulesOrderStatus";
import { uploadTicketFile } from "../../../api/ticket/update";

const ticketPriority = [
  {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
];

const customCategory = {
  order : {
    id: 1,
    name: "سفارش",
    departmentId: 1
  },
  parcel: {
    id: 2,
    name: "محموله", 
    departmentId: 1
  }
}

const codes = {
  order: ['FULFILLMENT', 'DELIVERY'],
  parcel: ['INBOUND'],
}

interface CreateTicketModalProps {
  handleCloseModal: () => void
  getTickets?: () => void
  linkId?: string
  linkType?: string
  pageCategory?: any
}
 
const CreateTicket: FunctionComponent<CreateTicketModalProps> = ({handleCloseModal, getTickets, linkId, linkType, pageCategory}) => {
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState<any>('');
  const [category, setCategory] = useState<string>('')
  const [priority, setPriority] = useState<string>('NORMAL')
  const [subject, setSubject] = useState<string>('')
  const [categories, setCategories] = useState([])
  const [subjects, setSubjects] = useState([])
  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
  useForm({
    defaultValues: {
      type: "NONE",
      file: null,
      title: null,
      priority: '',
      subject: '',
      msg: '',
      category: ''
    },
  });

  useEffect(() => {
    getCategoryList()
    // if(!linkType) {
    // }else {
    //   setValue('category', 'سفارش')
    //   setCategory(customCategory[linkType].id);
    //   setValue('subject', undefined)
    //   setSubject(undefined)
    //   getSubjectList(customCategory[linkType].id)
    // }
  }, [])
  const handleRemoveFile = () => {
    setFile(null);
    setValue('file', null);
  };

  const handleFileDropped = (acceptedFile: any) => {
    if(acceptedFile.size > 10000000) {
      return handleNotfication('حجم فایل ارسالی بیش از 10 مگابایت است.', 'error')
    }
    setFile(acceptedFile);
  };

  const getCategoryList = async () => {
    const response = await getCategories({})
    let list;
    if(linkType === 'order') {
      list = response.data.filter(el => ['FULFILLMENT', 'DELIVERY'].includes(el.code))
    }else if(linkType === 'parcel') {
      list = response.data.filter(el => ['INBOUND'].includes(el.code))
    }else {
      list = response.data.filter(el => !['FULFILLMENT', 'DELIVERY', 'INBOUND'].includes(el.code))
    }
    setCategories(list)
  }

  const getSubjectList = async (id:string) => {
    const response = await getSubjects({categoryId:id})
    setSubjects(response.data)
    setSubject(response.data[0].id)
  }

  const onPriorityChange = (e: any) => {
    setPriority(e.target.value)
  }

  const onSubmit = async (data: any) => {
    const body = {
      title: data.title,
      priority: priority,
      text: data.msg,
      categoryId: category,
      subjectId: subject,
      linkId,
      linkType
    }
    try {
      setLoading(true);

      const res = await createTicket(body)
      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      getTickets && getTickets()
      file && await uploadFile(file, res.data.content.id, res.data.id)
      handleCloseModal()
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }

      handleError(err);
    } finally {
      setFile(null);
      setLoading(false);
      setValue('file', null);
    }
  };

  const uploadFile = async (ticketFile: any, id: number, ticketId: string) => {
    const form = new FormData()
    form.append('file', ticketFile)
    await uploadTicketFile(form, id, ticketId)
  }

  return ( <form onSubmit={handleSubmit(onSubmit)}>
    <DialogContent style={{ paddingTop: '0' }}>
      <Grid container direction="row" spacing={2}>
        <Grid item md={4} lg={4}>
        <Autocomplete
            id="category"
            options={categories}
            getOptionLabel={option => option.name}
            disableClearable={true}
            onChange={(e: any, newValue: any | null | undefined) => {
              if (newValue) {
                setCategory(newValue.id);
                setValue('subject', undefined)
                setSubject(undefined)
                getSubjectList(newValue.id)
              }
            }}
            renderInput={params => (
              <TextField
                name="category"
                inputRef={register({ required: true })}
                {...params}
                label="دسته‌بندی"
                fullWidth
                variant="outlined"
              />
            )}
          />
          {/* {!linkType ? <Autocomplete
            id="category"
            options={categories}
            getOptionLabel={option => option.name}
            disableClearable={true}
            disabled={!!linkType}
            onChange={(e: any, newValue: any | null | undefined) => {
              if (newValue) {
                setCategory(newValue.id);
                setValue('subject', undefined)
                setSubject(undefined)
                getSubjectList(newValue.id)
              }
            }}
            renderInput={params => (
              <TextField
                name="category"
                inputRef={register({ required: true })}
                {...params}
                label="دسته‌بندی"
                fullWidth
                variant="outlined"
              />
            )}
          /> : <TextField value={customCategory[linkType].name} variant="outlined" disabled/>} */}
          <FormHelperText error focused>
            {errors.category && 'دسته‌بندی الزامی میباشد'}
          </FormHelperText>
        </Grid>
        <Grid item md={4} lg={4}>
          <Autocomplete
            id="subject"
            options={subjects}
            disabled={!category}
            onChange={(event: any, newValue: any | null) => {
              setSubject(newValue.id);
            }}
            getOptionLabel={option => option?.body}
            disableClearable={true}
            renderInput={params => (
              <TextField
                name="subject"
                {...params}
                inputRef={register({ required: true })}
                label="موضوع"
                variant="outlined"
              />
            )}
          />
          <FormHelperText error focused>
            {errors.category && 'موضوع الزامی میباشد'}
          </FormHelperText>
        </Grid>
        <Grid item md={4} lg={4}>
          <div style={{ marginTop: '2px' }}>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name="title"
              label="عنوان (اختیاری)"
              error={errors.title}
              rules={{ required: false }}
              as={
                <TextField
                  style={{ marginTop: '16px', marginBottom: '16px' }}
                  fullWidth
                  variant="outlined"
                />
              }
            />
          </div>
          {errors.title?.type == "required" && <FormHelperText error focused>
            عنوان الزامی می‌باشد
          </FormHelperText>}
          {errors.title?.type == "minLength" && <FormHelperText error focused>
            حداقل 4کاراکتر وارد شود
          </FormHelperText>}
        </Grid>
      </Grid>

      <Controller
        control={control}
        id="msg"
        name="msg"
        rules={{ required: true }}
        error={errors.msg}
        as={
          <TextField
            inputProps={{
              style: {
                minHeight: '120px',
                maxHeight: '240px',
                padding: '0 8px',
              },
            }}
            margin="normal"
            multiline
            label="متن پیام"
            variant="outlined"
            fullWidth
          />
        }
      />

      <FormHelperText error focused>
        {errors.msg && 'متن پیام الزامی است'}
      </FormHelperText>

      <Grid container direction="row" spacing={2}>
        <Grid item md={12} lg={12}>
          <RonadDropzone
            register={register}
            onDropped={handleFileDropped}
          />
        </Grid>
      </Grid>
      {file && (
        <Grid
          style={{
            textAlign: 'left',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <IconButton
            aria-label="close"
            style={{ marginLeft: 'auto' }}
            onClick={handleRemoveFile}
          >
            <RonadIcons name="times" className='text-danger'  size={0.8}/>
          </IconButton>
          <span style={{ marginTop: '14px' }}>
            <span style={{ fontWeight: 'bold' }}> {file.name} </span>
            <span>( {file.size} KB )</span>
          </span>
        </Grid>
      )}
    </DialogContent>
    <DialogActions>
      <Grid
        container
        spacing={1}
        direction="row-reverse"
        style={{ marginBottom: '8px' }}
      >
        <Grid item>
          <Button
            type="submit"
            variant="contained"
            size="large"
            color="primary"
            style={{ marginLeft: '24px' }}
            disabled={loading}
          >

            {loading ? <CircularProgress style={{ height: "30px", width: "30px" }} /> : `ارسال پیام`}
          </Button>
        </Grid>

        {handleCloseModal ? (
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              size="large"
              color="default"
              onClick={handleCloseModal}
            >
              {`بازگشت`}
            </Button>
          </Grid>
        ) : null}
      </Grid>
    </DialogActions>
  </form>);
}
 
export default CreateTicket;